/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { updateTrackModelSchema } from "../updateTrackModelSchema.ts";
import { z } from "zod";

export const putApiTracksIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор обновляемого трека")
    })

/**
 * @description Идентификатор обновляемого трека
 */
export const putApiTracksId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации | Автор не является владельцем альбома
 */
export const putApiTracksId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiTracksId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiTracksId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Трек не найден | Автор не найден | Альбом не найден | Жанр не найден
 */
export const putApiTracksId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiTracksId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiTracksIdMutationRequestSchema = z.lazy(() => updateTrackModelSchema).describe("Тело запроса")

export const putApiTracksIdMutationResponseSchema = z.lazy(() => putApiTracksId200Schema)